import apiClient from "./apiClient";

export const listImpactThemes = () => apiClient.get("/impact-themes");
export const createImpactTheme = (payload) => apiClient.post("/impact-themes", payload);
export const updateImpactTheme = (themeId, payload) => apiClient.put(`/impact-themes/${themeId}`, payload);
export const deleteImpactTheme = (themeId) => apiClient.delete(`/impact-themes/${themeId}`);

export const getImpactThemeLevels = (themeId) => apiClient.get(`/impact-themes/${themeId}/levels`);
export const updateImpactThemeLevels = (themeId, payload) =>
  apiClient.put(`/impact-themes/${themeId}/levels`, payload);
